export const MercedesArrowForward = (props) => (
    <svg 
        width={props.size || 9} 
        height={props.size || 15} 
        viewBox="0 0 9 15" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        {...props}>
            <path d="M1.4 14.2L8.4 7.1L1.4 0L0 1.4L5.6 7.1L0 12.7L1.4 14.2Z" fill="#414141"/>
    </svg>
);